"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Aug 20 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Converter for SettingsChildrenStats. It is meant for JSON conversions only.
 *
 * @author Radek Beran
 */


var SettingsChildrenStatsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SettingsChildrenStatsConverter, _DataObjectConverter_);

  function SettingsChildrenStatsConverter() {
    _classCallCheck(this, SettingsChildrenStatsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SettingsChildrenStatsConverter).apply(this, arguments));
  }

  return SettingsChildrenStatsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SettingsChildrenStatsConverter = SettingsChildrenStatsConverter;